import React, { forwardRef } from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'

const RecentList = forwardRef<SVGSVGElement, SvgIconProps>(
  function RecentList(props, ref) {
    return (
      <SvgIcon ref={ref} {...props}>
        <path d="m18.700664,6.41428l0,1.57894l-13.4019,0l0,-1.57894c0,-0.276 0.20911,-0.49342 0.47456,-0.49342l12.45278,0c0.26545,0 0.47456,0.21742 0.47456,0.49342zm-1.63286,-3.29586l0,1.57895l-10.13618,0l0,-1.57895c0,-0.276 0.20911,-0.49342 0.47456,-0.49342l9.18706,0c0.26545,0 0.47456,0.21742 0.47456,0.49342zm2.79021,6.09829l0.00002,0c0.26619,0 0.47455,0.21742 0.47455,0.49342l0.00075,11.17145c0,0.276 -0.20911,0.49342 -0.47456,0.49342l-15.71755,0c-0.26545,0 -0.47456,-0.21742 -0.47456,-0.49342l0,-11.17145c0,-0.276 0.20911,-0.49342 0.47456,-0.49342l15.71679,0z" />
      </SvgIcon>
    )
  },
)

export default RecentList
